module.exports = __webpack_public_path__ + "static/media/logo_01.9fcd6f11.svg";